"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bigimage = void 0;
const cash_dom_1 = __importDefault(require("cash-dom"));
class Bigimage {
    constructor(element, showMainnav = true) {
        this.element = null;
        this.showMainnav = false;
        this._checkPosition = () => {
            var _a;
            const imageHeight = this.element.height();
            const brandingHeight = (0, cash_dom_1.default)('.branding', this.element).height();
            const logoHeight = (0, cash_dom_1.default)('.tt-logo', this.element).height();
            let logoTop = (_a = (0, cash_dom_1.default)('.tt-logo', this.element).offset()) === null || _a === void 0 ? void 0 : _a.top;
            if (document.body.scrollTop >= (imageHeight - logoHeight) / 2 + logoHeight - brandingHeight) {
                this.element.addClass('match');
                if (this.showMainnav) {
                    (0, cash_dom_1.default)('#mainnav').addClass('fadeIn');
                }
            }
            else {
                this.element.removeClass('match');
                if (this.showMainnav) {
                    (0, cash_dom_1.default)('#mainnav').removeClass('fadeIn');
                }
            }
        };
        this.element = element;
        this.showMainnav = showMainnav;
        if (this.showMainnav) {
            (0, cash_dom_1.default)('#mainnav').removeClass('fadeOut');
        }
        //this._checkPosition();
        window.onscroll = (event) => {
            // console.log(event, $('.tt-logo', element).offset());
            this._checkPosition();
        };
    }
}
exports.Bigimage = Bigimage;
